export default "__VITE_ASSET__8cac7efe__"